import React, { useEffect, useState,useImperativeHandle,forwardRef,useRef,useContext} from 'react'
import { $isNotNullUndefine, $Msg_AddressDetails, capitalizeFirstLetter, initMapScript, isNotallowspecialRegex, isNullUndefine, isNumberAndSlash, isNumberAndSpaceRegex } from '../control/Constant'
// import {Row, Col, Modal,Button,Form} from 'react-bootstrap';
// import { postApiCall } from '../../components/Reusable/ReusableCom';
// import { Api_Url } from '../../components/network/UrlPath';
// import { $AHelper } from '../Helper/$AHelper';
// import { isNullUndefine } from '../../components/Reusable/ReusableCom';
// import { globalContext } from '../../pages/_app';
// import { input } from '../Custom/CustomComponent';
// import { CustomButton } from '../Custom/CustomButton';
// import { $Msg_AddressDetails } from '../Helper/$MsgHelper';
// import { initMapScript } from '../../components/control/AHelper';
// import { useLoader } from '../utils/utils';
import konsole from '../network/konsole'

const userProfileJson = () => {return { id: 0, merchantCustomerId: "", customerProfileId: "", userId: "", profileType: "",isDeleted: false,createdBy: "",isActive: true}}
const userCardJson = () => {return {id: 0, userProfileId: 0, cardNickName: "", paymentProfileId: "", customerProfileId: "", 
                           cardNumber: "", expireDate: "", cardType: "", cardIsDeleted: false, isDefault: false, streetAddress: "",
                            apartmentNo: "", city : "", state: "", zipCode: "", cardIsActive: true, remarks: "", createdBy: "",
                            updatedBy :"" ,userLoginId:"",userId:"",firstName:"" ,lastName:"",emailId:"" ,phoneNumber:""}}

const NewPaymentModal = (props,ref) => {  
  const formOnlyUse = props?.formOnlyUse;
//   const { setdata, confirm } = useContext(globalContext);
  const newObjErr = () => ({cityErr: "", stateErr: "", zipCodeErr: "",streetAddressErr:'',expireDateErr:"",cardNumberErr:"",cardNickNameErr:"",cardCvvErr:""});
    const userDetail = JSON.parse(sessionStorage.getItem("stateObj"))
    const primaryUserId = sessionStorage.getItem("SessPrimaryUserId") 
    const loginUserId = sessionStorage.getItem("loggedUserId")
    // const { setWarning } = useContext(globalContext)
    const searchInput = useRef(null)
    const [errMsg, setErrMsg] = useState(newObjErr());
    const [isUpadteCard, setIsUpadteCard] = useState(true)
    // const [userCardJsonSet, setUserCardJsonSet] = formOnlyUse ? [props?.cardFormData, props?.setCardFormData] : useState({...userCardJson(),createdBy : loginUserId})
    const [localUserCardJsonSet, setLocalUserCardJsonSet] = useState({ 
  ...userCardJson(), 
  createdBy: loginUserId 
});

const userCardJsonSet = formOnlyUse ? props?.cardFormData : localUserCardJsonSet;
const setUserCardJsonSet = formOnlyUse ? props?.setCardFormData : setLocalUserCardJsonSet;


    useEffect(()=>{
      if(formOnlyUse) {
        // setUserCardJsonSet(props.updateCard);
      } else {
        // setStateToUpdate()
      }
      for (let key in newObjErr()) {
      setErrMsg(prev => ({ ...prev, [key]: '' }));
      }
    },[props])

    // useImperativeHandle(ref,()=>({
    //   deleteCardDetails
    // }))


    const is24HoursOld = (updateon) => {
      const currentGMT = new Date().toISOString(); // Current time in GMT as ISO string
      const currentGMTTime = new Date(currentGMT).getTime(); // Convert current GMT to milliseconds
      const updateTime = new Date(updateon).getTime(); // Convert updateon to milliseconds  
      return (currentGMTTime - updateTime) >= 24 * 60 * 60 * 1000; // Compare time difference
  };

    // const setStateToUpdate = () =>{
    //   let parts = props.updateCard?.cardNickName?.split(" ");
    //   let firstName = parts[0] || "";
    //   let lastName = parts.slice(1).join(" "); // Combine everything after the first word for the last name

    //   let userLoggedInDetail=JSON.parse(sessionStorage.getItem('userLoggedInDetail')); 
    //   const {primaryEmailId, userMob } = userLoggedInDetail
    //   if(props.updateCard != undefined || props.updateCard != null){
    //      const mergeUpdateCardDetailObj = {...userCardJson(), ...props.updateCard,customerProfileId:props?.profileDetails?.[0]?.customerProfileId,updatedBy:loginUserId,userLoginId:userDetail?.loggenInId,emailId:primaryEmailId,phoneNumber:userMob,userId:primaryUserId,firstName:firstName,lastName:$AHelper.$isNotNullUndefine(lastName) ? lastName : firstName,isDefault:false}
    //      const {createdBy, createdOn, updatedOn, ...rest} = mergeUpdateCardDetailObj
    //      setUserCardJsonSet(rest)
    //     let compaerDate = props.updateCard?.updatedOn == "0001-01-01T00:00:00" ? props.updateCard?.createdOn : props.updateCard?.updatedOn
    //     setIsUpadteCard(is24HoursOld(compaerDate))  
    //   }
    // }

    const formatCreditCardNumber = (value) => {
        const digitsOnly = value?.replace(/\D/g, '');
        const formattedValue = digitsOnly?.replace(/(\d{4}(?=\d))/g, '$1 ');
        return formattedValue;
    };
 
    const expiryDateValidationInput = (data) => {
      let value = data?.replace(/\D/g, ''); // Remove non-digit characters
    
      // Ensure month is between 01 and 12
      value = value?.replace(/^(\d{2})/, (match, month) => {
        if (parseInt(month) < 1 || parseInt(month) > 12) {
          return '0';
        }
        return month;
      });
    
      // Add slash after the second digit of the month
      value = value?.replace(/^(\d{2})(\d{0,2})/, '$1/$2');
    
      // Remove slash if the last character being deleted is a slash
      value = value?.replace(/\/$/, '');
    
      // Truncate year to 2 digits
      value = value?.replace(/(\d{4})\d*/, '$1');
    
      return value; // Return the updated input value
    };


    const validateContact = () => {
      const isValidAddressLine1 = validateField(userCardJsonSet?.streetAddress, 'streetAddressErr');
      const isValidCardNickName = validateField(userCardJsonSet?.cardNickName, 'cardNickNameErr');
      const isValidCardNumber = validateField(userCardJsonSet?.cardNumber, 'cardNumberErr');
      const isValidExpireDate = validateField(userCardJsonSet?.expireDate, 'expireDateErr');
      const isValidCardCvv = isNullUndefine(userCardJsonSet?.paymentProfileId) ? validateField(userCardJsonSet?.cardCvv, 'cardCvvErr') : true;
      const isValidCity = validateField(userCardJsonSet?.city, 'cityErr');
      const isValidState = validateField(userCardJsonSet?.state, 'stateErr');
      const isValidZipcode = validateField(userCardJsonSet?.zipCode, 'zipCodeErr');  
      return   isValidCardNickName && isValidCardNumber && isValidExpireDate && isValidCity && isValidState && isValidZipcode && isValidAddressLine1 && isValidCardCvv;
    };
    const validateField = (field, errorMessageKey, needErrorFocus) => {
      if (!$isNotNullUndefine(field)) {
        setErrMsg(prev => ({ ...prev, [errorMessageKey]: $Msg_AddressDetails[errorMessageKey] }));
        return false;
      } else {
        setErrMsg(prev => ({ ...prev, [errorMessageKey]: '' }));
      }
      return true;
    };
      
    
     
    const handleCardDetails = (e,key) => {
      let updatedValue = '';
      switch (key) {
        case "cardNumber":
          updatedValue = isNumberAndSpaceRegex(e) ? e?.replace(/\s/g, "") : '';
          break;
        case "expireDate":
          updatedValue = isNumberAndSlash(e) ? e : '';
          break;
        case "cardNickName":
          updatedValue = isNotallowspecialRegex(e) ? capitalizeFirstLetter(e) : '';
          break;
        case "cardCvv":
          updatedValue = $isNotNullUndefine(e) && (isNaN(Number(e)) != true) ? Number(e) : '';
          break;
        default:
          updatedValue = e;
      }
    
      if(key == "cardNickName" && $isNotNullUndefine(updatedValue)){
        let parts = updatedValue?.split(" ") || [];
        let firstName = parts[0] || ""; // Default to an empty string if parts[0] is undefined
        let lastName = parts.length > 1 ? parts.slice(1).join(" ") : firstName; // Use firstName if no last name exists
        
        setUserCardJsonSet(prev => ({
          ...prev,
          firstName,
          lastName,
          cardNickName: updatedValue
        }));

      } else{
        setUserCardJsonSet(prev => ({
          ...prev,
          [key]: updatedValue
        }));     
      }
      hideErrMsg(`${key}Err`, errMsg)
     
    };


    const hideErrMsg = (key, errMsg) => {
      if ($isNotNullUndefine(errMsg[key])) {
        setErrMsg(prev => ({ ...prev, [key]: '' }));
      }
    }
    // const makeCardDefault = async() =>{ 
    //   let confirms = await confirm(true,'Are you sure you want to make this card default ?','Confirmation')
    //   if(confirms == false) return;
    //   setUserCardJsonSet(prev => ({
    //     ...prev,
    //     ["isDefault"]: false
    //   }));
    // }
    


    const validateExpirationDate = (date) => {
      // Check if the date matches the mm/yy format
      const regex = /^(0[1-9]|1[0-2])\/\d{2}$/;
      if (!regex.test(date)) {
        return false;
      }
  
      // Check if the date is in the future
      const [month, year] = date?.split('/');
      const expirationDate = new Date(`20${year}`, month);
      const currentDate = new Date();
  
      return expirationDate > currentDate;
    };
    const toasterAlert = (type, description) => {
    props?.setToast({ message: description, type: type })      
    }
    
    const validate = () =>{     
      const cardNumbers =  userCardJsonSet?.cardNumber?.toString()
      if(isNullUndefine(userCardJsonSet?.cardNickName) == true){
        toasterAlert("error","Please enter card holder name")
        return;
      }
      if(isNullUndefine(cardNumbers) == true){
        toasterAlert("error","Please enter card number")
        return;
      }
      if(!(cardNumbers?.length >= 14 && cardNumbers?.length <= 16)){
        toasterAlert("error","Please enter correct card number")
        return;
      }
      if (!validateExpirationDate(userCardJsonSet?.expireDate)) {
        toasterAlert("error","Please enter correct expiration date.")
        return;
      }
      if(isNullUndefine(userCardJsonSet?.expireDate) == true){
        toasterAlert("error","Please enter expiration date")
        return;
      }
      if(isNullUndefine(userCardJsonSet?.paymentProfileId) && isNullUndefine(userCardJsonSet?.cardCvv)){
        toasterAlert("error","Please enter expiration date")
        return;
      }
      return true;
    }

    const saveAndEditCardDetails = () =>{
      if(isUpadteCard == false){
        toasterAlert("error", "You can update your card once every 24 hours. The 24-hour period starts after your subscription or card update.")
        // alert('You can update your card once every 24 hours. The 24-hour period starts after your subscription or card update.')
        return;
      }
      if(validateContact() && validate()){ 
      if(formOnlyUse) return props?.onSubmit(userCardJsonSet);
      if(props.updateCard != undefined || props.updateCard != null){
               userCard(userCardJsonSet,"updateCardDetail")
      }
      else{
        if(props?.profileDetails?.status == 404){
          // userProfile()
        }
        else{
          const cardJson = {...userCardJsonSet,userProfileId:props?.profileDetails?.[0]?.id}
          userCard(cardJson)
        }
      } 
    }
    }

    const deleteCardDetails = (data) =>{
      const {createdBy, createdOn, updatedOn, updatedBy, ...rest} = data
      const json = {...rest, updatedBy : loginUserId,customerProfileId : "", cardIsDeleted : true, cardIsActive : false}  
      userCard(json,"deleteCardDetail")
    }

    // const userProfile = async() => {  
    //     useLoader(true)    
    //     const profileJson = {...userProfileJson(),merchantCustomerId : `AOUL-${userDetail?.loggenInId}`,userId:primaryUserId,createdBy: loginUserId}
    //     const responseData = await postApiCall("POST",Api_Url.postUserProfile,profileJson)
    //     useLoader(false)
    //     const userProfileId = responseData?.data?.data?.id
    //     const cardJson = {...userCardJsonSet,userProfileId:userProfileId}
    //     userCard(cardJson)
    // }

    const userCard = async(cardJson,cardEvent) =>{     
       const checkAlreadyAddedCard = props?.alreadyAddedCards?.some(item =>
        item.cardNumber === cardJson.cardNumber &&
        [null, false].includes(item.cardIsDeleted) &&
        item.expireDate == cardJson.expireDate &&
        item.streetAddress == cardJson.streetAddress &&
        item.zipCode === cardJson.zipCode &&
        item.state === cardJson.state &&
        item.city === cardJson.city
      );
      if (!checkAlreadyAddedCard) {
        // useLoader(true)
        // const responseData = await postApiCall("POST", Api_Url.postUserCard, cardJson)
        // const { userSubscriptionId, subscriptionId, authorizeSubscriptionId } = props?.subsDetails
        // const { customerProfileId } = props?.profileDetails?.[0] || {}
        // const { cards, userId } = responseData?.data?.data || {}
        // const upDateJson = {
        //   "userSubscriptionId": userSubscriptionId,
        //   "subscriptionId": subscriptionId,
        //   "authorizeSubscriptionId": authorizeSubscriptionId,
        //   "authorizeCustomerProfileId": customerProfileId,
        //   "authorizePaymentProfileId": cards[0]?.paymentProfileId || null,
        //   "userLoginId": userDetail?.loggenInId,
        //   "userId": userId,
        //   "isOneTimePay": false
        // }
        
        // const _resultupdateUserAuthSubscription = await postApiCall('POST', Api_Url.updateUserAuthSubscription, upDateJson);
        // if (_resultupdateUserAuthSubscription !== 'err') {
        //   toasterAlert("successfully", `Card details ${cardEvent == "deleteCardDetail" ? "deleted" : cardEvent == "updateCardDetail" ? "updated" : "added"} successfully`)

        // }
        // if(responseData != 'err'){
        // toasterAlert("success", `Card details ${cardEvent == "deleteCardDetail" ? "deleted" : cardEvent == "updateCardDetail" ? "updated" : "added"} successfully`)
        // }



        // props?.useLoader(false)
        // props?.handleClose()
      }
      else {
        toasterAlert("error", "Card already exists.")
      } 
    }
      //////////////////autoComplete address   
  const autoCompleteAddress = (value, key) => {
    setUserCardJsonSet(prev => ({
      ...prev,
      [key]: value.target.value
    }));
    hideErrMsg(`${key}Err`, errMsg)
    setErrMsg(newObjErr())
    initMapScript().then(() => initAutoComplete());
  }
  ////// AUTOCOMPLETE ADDRESS
  const initAutoComplete = () => {
    if (!searchInput.current.value) return;
    const autocomplete = new window.google.maps.places.Autocomplete(
      searchInput.current
    );
    autocomplete.setFields(["address_component", "geometry"]);
    autocomplete.addListener("place_changed", () =>
      onChangeAddress(autocomplete)

    );
  };
  const extractAddress = (place) => {
    const address = {
      city: "",
      state: "",
      zip: "",
      county: "",
      country: "",
      plain() {
        const city = city ? city + ", " : "";
        const zip = zip ? zip + ", " : "";
        const county = county ? county + "," : "";
        const state = state ? state + ", " : "";
        const country = country || "";
        return city + zip + state + country;
      },
    };

    if (!Array.isArray(place?.address_components)) {
      return address;
    }
    let postalCodeSuffix = "";
    let unWanted = ['USA', 'UK'];
    place.address_components.forEach((component) => {
      const types = component.types;
      const value = component.long_name;
      if (types.includes("locality")) {
        address.city = value;
        unWanted.push(component.long_name, component.short_name);
      }
      if (types.includes("administrative_area_level_1")) {
        address.state = value;
        unWanted.push(component.long_name, component.short_name);
      }
      if (types.includes("administrative_area_level_2")) {
        if (value.includes("County") || value.includes("county")) {
          let removedCountyFromValue = value.replace(/County|county/g, "")
          address.county = removedCountyFromValue;
        }
        else { address.county = value; }
        unWanted.push(component.long_name, component.short_name);
      }
      if (types.includes("postal_code")) {
        address.zip = value;
        unWanted.push(component.long_name, component.short_name);
      }
      if (types.includes("country")) {
        address.country = value;
        unWanted.push(component.long_name, component.short_name);
      }
      if (types.includes("county")) {
        address.country = value;
        unWanted.push(component.long_name, component.short_name);
      }
      if (types?.includes("postal_code_suffix")) {
        postalCodeSuffix = value;
        unWanted.push(component.long_name, component.short_name);
      }
    });

    if (postalCodeSuffix) address.zip += '-' + postalCodeSuffix;
    unWanted.push(address.zip);

    address.unWanted = unWanted;
    return address;
  };

  const onChangeAddress = (autocomplete) => {
    const place = autocomplete.getPlace();
    const lat = place?.geometry?.location?.lat();
    const long = place?.geometry?.location?.lng();
    setUserCardJsonSet((prev) => ({
      ...prev,
      streetAddress: searchInput?.current?.value,
    }));
    setAddress(extractAddress(place));
  };
  const setAddress = (address) => {
    address = formateAddressLine1(address);
    setUserCardJsonSet((prev) => ({
      ...prev,
      city: address.city,
      state: address.state,
      zipCode: address.zip,
    }));

  };
  const formateAddressLine1 = (address) => {
    if (!address || !searchInput?.current?.value || !address.unWanted?.length) return address;
    const curAddressLine1 = searchInput?.current?.value;
    const firstCommaIndex = curAddressLine1.indexOf(',');
    if (firstCommaIndex == -1) {
      address.unWanted = undefined;
      return address;
    }


    let secondPartString = " " + curAddressLine1?.slice(firstCommaIndex) + " ";

    for (let i = 0; i < address.unWanted.length; i++) {
      const searchWord = new RegExp(`( |,)(${address.unWanted[i]})( |,)`, "g");
      secondPartString = secondPartString?.replace(searchWord, " ");
    }

    let finalSecondPart = "";
    let lastChar = "";
    for (let i = 0; i < secondPartString.length; i++) {
      const curChar = secondPartString[i];
      if (curChar == " " || curChar == ",") {
        if (finalSecondPart.length == 0) continue;
        if (lastChar != " " && (lastChar != "," || curChar == " ")) finalSecondPart += curChar;
      } else {
        finalSecondPart += curChar;
      }
      lastChar = curChar;
    }

    if (finalSecondPart.length) {
      const lastIndexOfCom = finalSecondPart.lastIndexOf(",");
      if (finalSecondPart.length - lastIndexOfCom <= 2) finalSecondPart = finalSecondPart.slice(0, lastIndexOfCom);
      searchInput.current.value = curAddressLine1.slice(0, firstCommaIndex) + ", " + finalSecondPart;
    }
    else searchInput.current.value = curAddressLine1.slice(0, firstCommaIndex);

    address.unWanted = undefined;
    return address;
  }
    const setAddressLine1Data = () => {
      setUserCardJsonSet((prev) => ({
        ...prev,
        streetAddress: searchInput?.current?.value,
      }));
    }

    const MainForm = (
        <>
<div className="w-full" key="costumModal-body">
  <div
    className={`overflow-y-auto overflow-x-hidden ${
      formOnlyUse ? 'p-0 max-h-none' : 'p-4 max-h-[35rem]'
    }`}
  >
    <div className="space-y-6">
      {/* Cardholder Name & Card Number */}
      <div className="flex flex-wrap gap-4">
        <div className="w-full md:min-w-[48%] w-[48%]">
        <label className="font-semibold text-sm">Cardholder Name*</label>
          <input
            tabIndex={1}
            name="cardNickName"
            placeholder="Enter cardholder name"
            value={userCardJsonSet?.cardNickName ?? ''}
            onChange={(e) => handleCardDetails(e.target.value, "cardNickName")}
            className="w-full mt-1 border border-gray-400 rounded-md p-2 text-sm"
          />
          {errMsg.cardNickNameErr && (
            <span className="text-red-600 text-sm">{errMsg.cardNickNameErr}</span>
          )}
        </div>
        <div className="w-full md:min-w-[50%] w-[50%]">
          <label className="font-semibold text-sm">Card Number*</label>
          <input
            type="text"
            tabIndex={2}
            placeholder="Enter card number"
            maxLength="19"
            name="cardNumber"
            value={formatCreditCardNumber(userCardJsonSet?.cardNumber) ?? ''}
            onChange={(e) => handleCardDetails(e.target.value, 'cardNumber')}
            className="w-full mt-1 border border-gray-400 rounded-md p-2 text-sm"
          />
          {errMsg.cardNumberErr && (
            <span className="text-red-600 text-sm">{errMsg.cardNumberErr}</span>
          )}
        </div>
      </div>

      {/* Expiration Date & CVV */}
      <div className="flex flex-wrap gap-4">
        <div className="w-full md:min-w-[48%] w-[48%]">
          <label className="font-semibold text-sm">Expiration Date*</label>
          <input
            type="text"
            tabIndex={3}
            placeholder="Enter expire date"
            maxLength="5"
            name="expireDate"
            value={expiryDateValidationInput(userCardJsonSet?.expireDate) ?? ''}
            onChange={(e) => handleCardDetails(e.target.value, 'expireDate')}
            className="w-full mt-1 border border-gray-400 rounded-md p-2 text-sm"
          />
          {errMsg.expireDateErr && (
            <span className="text-red-600 text-sm">{errMsg.expireDateErr}</span>
          )}
        </div>
        {!$isNotNullUndefine(userCardJsonSet?.paymentProfileId) && (
          <div className="w-full md:min-w-[50%] w-[50%]">
            <label className="font-semibold text-sm">CVV*</label>
            <input
              type="text"
              tabIndex={4}
              placeholder="Enter CVV"
              maxLength="4"
              name="cardCvv"
              value={userCardJsonSet?.cardCvv ?? ''}
              onChange={(e) => handleCardDetails(e.target.value, 'cardCvv')}
              className="w-full mt-1 border border-gray-400 rounded-md p-2 text-sm"
            />
            {errMsg.cardCvvErr && (
              <span className="text-red-600 text-sm">{errMsg.cardCvvErr}</span>
            )}
          </div>
        )}
      </div>

      {/* Billing Address */}
      <div>
        <label className="font-semibold text-sm">Billing Address*</label>
        <input
          tabIndex={4}
          type="text"
          placeholder="Enter billing address"
          name="billingAddress"
          id="streetAddress"
          ref={searchInput}
          defaultValue={userCardJsonSet?.streetAddress}
          onBlur={setAddressLine1Data}
          onChange={(e) => autoCompleteAddress(e, 'streetAddress')}
          className="w-full mt-1 border border-gray-400 rounded-md p-2 text-sm"
        />
        {errMsg.streetAddressErr && (
          <span className="text-red-600 text-sm">{errMsg.streetAddressErr}</span>
        )}
      </div>

      {/* Apartment No */}
      <div>
        <input
          tabIndex={5}
          name="apartmentNo"
          placeholder="Enter house no"
          value={userCardJsonSet?.apartmentNo ?? ''}
          onChange={(e) => handleCardDetails(e.target.value, "apartmentNo")}
          className="w-full border border-gray-400 rounded-md p-2 text-sm"
        />
      </div>

      {/* City, State, Zip Code */}
      <div className="flex flex-wrap gap-4">
        <div className="w-full md:min-w-[48%] w-[48%]">
          <input
            tabIndex={6}
            name="city"
            placeholder="Enter city"
            value={userCardJsonSet?.city ?? ''}
            onChange={(e) => handleCardDetails(e.target.value, "city")}
            className="w-full border border-gray-400 rounded-md p-2 text-sm"
          />
          {errMsg.cityErr && (
            <span className="text-red-600 text-sm">{errMsg.cityErr}</span>
          )}
        </div>
        <div className="w-full md:min-w-[50%] w-[50%]">
          <input
            tabIndex={7}
            name="state"
            placeholder="Enter state"
            value={userCardJsonSet?.state ?? ''}
            onChange={(e) => handleCardDetails(e.target.value, "state")}
            className="w-full border border-gray-400 rounded-md p-2 text-sm"
          />
          {errMsg.stateErr && (
            <span className="text-red-600 text-sm">{errMsg.stateErr}</span>
          )}
        </div>
        <div className="w-full md:min-w-[48%] w-[48%]">
          <input
            tabIndex={8}
            name="zipCode"
            placeholder="Enter zip code"
            value={userCardJsonSet?.zipCode ?? ''}
            onChange={(e) => handleCardDetails(e.target.value, "zipCode")}
            className="w-full border border-gray-400 rounded-md p-2 text-sm"
          />
          {errMsg.zipCodeErr && (
            <span className="text-red-600 text-sm">{errMsg.zipCodeErr}</span>
          )}
        </div>
      </div>
    </div>
  </div>
</div>

  
  
          {formOnlyUse != true ? <div className="modal-footer ">
            <p className='fw-bold fs-6' style={{ color: "#720D21" }}>Note: <span className='fs-6 fw-light'>You can update your card once every 24 hours. The 24-hour period starts after your subscription or card update.</span></p>
            {/* {([false.null].includes(userCardJsonSet?.isDefault)) &&
              <button className='btn-btn' tabIndex={9} onClick={() => makeCardDefault()}> Set as default {props?.modalType}</button>} */}
            <button tabIndex={10} onClick={() => saveAndEditCardDetails()}>{`${props?.updateCard ? "Update" : "Save"}`}</button>
  
          </div> : 
          <div className="mt-2 flex justify-end">
            <button className="px-3 py-2 bg-blue-500 text-white rounded-md hover:bg-blue-600" tabIndex={11} onClick={() => saveAndEditCardDetails()}>{"Save"}</button>
          </div>
          }
  
        </>)
  if(formOnlyUse) return (
    <>
    {MainForm}
    </>
  )
  return (
      <>
          <div id="newModal" className='modals'>
              <div className="modal" style={{ display: 'block' }}>
                  <div className="modal-dialog costumModal" style={{ maxWidth: '500px', margin: 'auto' }}>
                      <div className="costumModal-content">
                          <div className="modal-header mt-3 ms-1">
                              <h5 className="modal-title">{`${props?.updateCard ? "Update" : "Add"} Payment Method`}</h5>
                              <img className='mt-0 me-1 cursor-pointer' onClick={props.handleClose} src='/icons/closeIcon.svg'></img>
                          </div>
                          {MainForm}
                      </div>
                  </div>
              </div>
          </div>

      </>

  )
}

export default NewPaymentModal